export class PreviousUrlModel {
  url: string[]
  paramMap: object
}